export enum CreateProposalActiveStep {
  ProposalType,
  ProposalValues,
}
export enum ProposalAction {
  BuyNft,
  SellNft,
  Discussion,
  Withdrawal,
  Transfer,
  UpdateGovernanceConfig,
  UpdateRoleConfig,
  AddSellPermission,
}

export enum OfferStatus {
  accepted = "accepted",
  initialised = "initialised",
  canceled = "canceled",
  initializeOnMe = "initializeOnMe",
  canceledOnMagic = "canceledOnMagic",
  pendingBuyNowExecutionOnMagicEden = "pendingBuyNowExecutionOnMagicEden",
  executedBuyNowOnMagicEden = "executedBuyNowOnMagicEden",
  pendingSellExecutionOnMagicEden = "pendingSellExecutionOnMagicEden",
  executedSellOnMagicEden = "executedSellOnMagicEden",
  fundsTransfered = "fundsTransfered",
  listedOnSolsea = "listedOnSolsea",
  executedBuyNowOnSolsea = "executedBuyNowOnSolsea",
  canceledOnSolsea = "canceledOnSolsea",
}

export enum OfferTypeSolana {
  Buy = "buy",
  Sell = "sell",
}

export enum VoteAction {
  Approve,
  Deny,
}

export enum CancellationType {
  DISCUSSION = "discussion",
  WITHDRAWAL = "withdrawal",
  BUY_P2P = "buy-p2p",
  SELL_P2P = "sell-p2p",
  BUY_ME = "buy-me",
  SELL_ME = "sell-me",
  SELL_SOLSEA = "sell-ss",
  BUY_SOLSEA = "buy-ss",
}

export enum ProposalTypeForProgram {
  BuyP2P,
  SellP2P,
  BuyNowMagicEden,
  SellMagicEden,
  TransferFunds,
  Discussion,
  Withdrawal,
  SellSolsea,
  BuySolsea,
  UpdateGovernanceConfig,
  UpdateRoleConfig,
  AddSellPermission,
}

export enum ProposalStatus {
  Pending = "pending",
  CreatedBuyP2P = "createdBuyP2P",
  CreatedSellP2P = "createdSellP2P",
  ExecutedBuyP2P = "executedBuyP2P",
  ExecutedSellP2P = "executedSellP2P",
  CreatedBuyNowMagicEden = "createdBuyNowMagicEden",
  ExecutedBuyNowMagicEden = "executedBuyNowMagicEden",
  FinishedBuyNowMagicEden = "finishedBuyNowMagicEden",
  CreatedSellMagicEden = "createdSellMagicEden",
  ExecutedSellMagicEden = "executedSellMagicEden",
  FinishedSellMagicEden = "finishedSellMagicEden",
  CreatedTransferFunds = "createdTransferFunds",
  ExecutedTransferFunds = "executedTransferFunds",
  CreatedDiscussion = "createdDiscussion",
  CreatedWithdrawal = "createdWithdrawal",
  ExecutedWithdrawal = "executedWithdrawal",
  CanceledByOwner = "canceledBuyOwner",
  ExecutedSolseaBuy = "executedSolseaBuy",
  ExecutedSolseaSell = "executedSolseaSell",
  UpdateGovernanceConfig = "updateGovernanceConfig",
  UpdateRoleConfig = "updateRoleConfig",
  AddSellPermission = "addSellPermission",
}

export enum ProposalTypeProgramString {
  BuyP2P = "buyP2P",
  SellP2P = "sellP2P",
  BuyNowMagicEden = "buyNowMagicEden",
  SellMagicEden = "sellMagicEden",
  TransferFunds = "transferFunds",
  Discussion = "discussion",
  Withdrawal = "withdrawal",
  SellSolsea = "sellSolsea",
  BuySolsea = "buySolsea",
  UpdateGovernanceConfig = "updateGovernanceConfig",
  UpdateRoleConfig = "updateRoleConfig",
  AddSellPermission = "AddSellPermission",
}

export enum OfferStatusSolana {
  Initialised,
  Accepted,
  Canceled,
  PendingBuyNowExecutionOnMagicEden,
  ExecutedBuyNowOnMagicEden,
  CanceledOnMagic,
  PendingSellExecutionOnMagicEden,
  ExecutedSellOnMagicEden,
  FundsTransfered,
}

export enum ProposalBuyOption {
  UnqMarketplace = "unqMarketplace",
  MagicEden = "magicEden",
  PeerToPeer = "peerToPeer",
  Solsea = "solsea",
}

export enum SellProposalOption {
  PeerToPeer = "peerToPeer",
  Solsea = "solsea",
}

export enum GoveranceType {
  DefaultGovernance,
  WithdrawalGovernance,
  TransferGovernance,
  ClubConfigGovernance,
  TradeApprovalGovernance,
}
